export function uniqueKey(prefix: string, ...ids: Array<string | number>): string {
  return `${prefix}-${ids.join('-')}`
}
